import './mls-french.scss';
// fixed https://jira.chimeinc.com/browse/CHIME-26415
const mls_french_while_id = [526, 726];

// fixed https://loftyinc.atlassian.net/browse/CHIME-59220
/**
 * @const {Array<number>} mls_adjust_position_banner_id
 * use for adjust the banner image in the detail page (listing detail & sold detail) & compliance check page
 * to focus on x: bottom, y: right   
 */
const mls_adjust_position_banner_id = [585];

export default ({ globalData }) => {
    let mlsOrgs = globalData.mlsOrgs || [];
    for (let i = 0; i < mlsOrgs.length; i++) {
        let mls = mlsOrgs[i];
        if (mls_french_while_id.includes(mls.id)) {
            document.body.classList.add('use_mls_french');
            return;
        }
        if (mls_adjust_position_banner_id.includes(mls.id)) {
            document.body.classList.add('use_mls_adjust_position_banner');
            return;
        }
    }
};
